const STORAGE_KEY = 'savedLogins_v1';
const MAX_LOGINS = 2;
const TTL_MS = 24 * 60 * 60 * 1000;

function encodeSecret(value) {
  try {
    return btoa(unescape(encodeURIComponent(String(value || ''))));
  } catch {
    return '';
  }
}

function decodeSecret(value) {
  try {
    return decodeURIComponent(escape(atob(String(value || ''))));
  } catch {
    return '';
  }
}

function toStore(items) {
  return items.map((x) => ({
    ...x,
    secret: typeof x.secret === 'string' && x.secret.length > 0 ? encodeSecret(x.secret) : '',
  }));
}

function safeParse(json) {
  try {
    return JSON.parse(json);
  } catch {
    return null;
  }
}

export function getSavedLogins() {
  const raw = localStorage.getItem(STORAGE_KEY);
  const parsed = safeParse(raw);
  const items = Array.isArray(parsed) ? parsed : [];
  return items
    .filter((x) => x && typeof x.email === 'string')
    .map((x) => ({
      email: String(x.email).trim().toLowerCase(),
      lastAuthAt: typeof x.lastAuthAt === 'number' ? x.lastAuthAt : 0,
      label: typeof x.label === 'string' ? x.label : '',
      secret: typeof x.secret === 'string' ? decodeSecret(x.secret) : '',
    }))
    .filter((x) => x.email.length > 0)
    .sort((a, b) => (b.lastAuthAt || 0) - (a.lastAuthAt || 0))
    .slice(0, MAX_LOGINS);
}

export function upsertSavedLogin(email, { label, secret } = {}) {
  const normalized = String(email || '').trim().toLowerCase();
  if (!normalized) return getSavedLogins();

  const items = getSavedLogins();
  const now = Date.now();
  const existingIdx = items.findIndex((x) => x.email === normalized);
  if (existingIdx >= 0) {
    items[existingIdx] = {
      ...items[existingIdx],
      lastAuthAt: now,
      label: typeof label === 'string' ? label : items[existingIdx].label,
      secret: typeof secret === 'string' && secret.length > 0 ? secret : items[existingIdx].secret,
    };
  } else {
    items.unshift({
      email: normalized,
      lastAuthAt: now,
      label: typeof label === 'string' ? label : '',
      secret: typeof secret === 'string' ? secret : '',
    });
  }
  const next = items
    .sort((a, b) => (b.lastAuthAt || 0) - (a.lastAuthAt || 0))
    .slice(0, MAX_LOGINS);
  localStorage.setItem(STORAGE_KEY, JSON.stringify(toStore(next)));
  return next;
}

export function removeSavedLogin(email) {
  const normalized = String(email || '').trim().toLowerCase();
  const next = getSavedLogins().filter((x) => x.email !== normalized);
  localStorage.setItem(STORAGE_KEY, JSON.stringify(toStore(next)));
  return next;
}

export function isLoginFresh(lastAuthAt) {
  if (!lastAuthAt) return false;
  return Date.now() - lastAuthAt <= TTL_MS;
}

